import Cell from './Cell';
const Table = ({ isLoading, data, headers, list})=>{

	let headerArr = [];
	headers.forEach(header=>{
		if(header.index !== 0){
			headerArr[header.index - 1] = header.title;
		}
	})

	let headerObjKeys = [];
	let headerNames = [];

	const fixedHeaderNumber = headers.filter(item=> item.type === "fixed").length;
	return(
		<table className={`[&>thead>tr>th[data-header='Retention']]:text-right [&>thead>tr>th]:px-7 [&>tbody>tr>td]:px-7 [&>thead>tr>th:first-child]:w-[18%] [&>thead>tr>th[data-header="Example"]]:w-1/4 
		[&>thead>tr>th[data-header="Example"]]:w-1/3 [&>tbody>tr>td[data-header='Retention']]:text-right [&>tbody>tr>td[data-header='Retention']]:text-right 
		[&>thead>tr>th[data-header='Retention']]:px-2 [&>thead>tr>th[data-header='Period']]:px-2 [&>thead>tr>th[data-header='Min/Max']]:pr-2 [&>thead>tr>th[data-header='From']]:pl-2 [&>thead>tr>th[data-header='From']]:min-w-28 [&>thead>tr>th[data-header='LRef']]:min-w-40 
		[&>tbody>tr>td[data-header='Retention']]:px-2 [&>tbody>tr>td[data-header='Period']]:px-2 [&>tbody>tr>td[data-header='Min/Max']]:pr-2 [&>tbody>tr>td[data-header='From']]:pl-2 
		[&>tbody>tr>td[data-header='stretch']]:!text-center [&>tbody>tr>td[data-header='stretch']]:text-grey-text 
		${isLoading ? "opacity-30 cursor-wait pointer-events-none" : ""}`}>
			<thead>
				<tr>
					{
						headerArr.map((header, index)=>{
							const obj = headers.find(item => item.title === header);
							const width = obj.title === "Examples" ? fixedHeaderNumber === 3 ? "40%" : null : null;
							if(obj){
								headerObjKeys.push(obj.key);
								headerNames.push(obj.title)
							}
							return obj ? (<th width={width} data-header={obj.title == 'Legal Ref' ? 'LRef' : obj.title} key={obj.index}>{obj.title}</th>) : null;
						})
					}
				</tr>
			</thead>
			<tbody>
				{
				    data.map((row, rowIndex)=>{
				    	let isRoType = row["ro_type"] ? true : false;

				    	return <tr key={rowIndex}>
				    		{
				    			headerNames.map((header, columnIndex)=>{
				    				return <Cell key={columnIndex} index={columnIndex} headerArr={headerArr} roType={isRoType} list={list} fixedHeaders={fixedHeaderNumber} headerKeys={headerObjKeys} row={row} rowIndex={rowIndex} header={header} />
				    			})
				    		}
				    	</tr>
				    })

				}
			</tbody>
		</table>
	)
}

export default Table;
